export default {
  state: {
    toMine: {}
  },
  mutations: {
    setMineData(state, val) {
      state.toMine = val
    }
  }
}